import {CognitoUserSession} from 'amazon-cognito-identity-js';
import userPool from './userPool';

const refreshToken = (): Promise<string> => {
  return new Promise((resolve, reject) => {
    const currentUser = userPool.getCurrentUser();
    if (currentUser) {
      currentUser.getSession((err: Error | null, session: CognitoUserSession | null) => {
        if (err) {
          reject(err);
        } else if (session && session.isValid()) {
          currentUser.refreshSession(session.getRefreshToken(), (refreshErr, newSession) => {
            if (refreshErr) {
              reject(refreshErr);
            } else {
              resolve(newSession.getAccessToken().getJwtToken());
            }
          });
        } else {
          reject(new Error('Session is not valid'));
        }
      });
    } else {
      reject(new Error('No current user'));
    }
  });
};

export default refreshToken;